import { render } from "./TestimonialCard.vue?vue&type=template&id=7d02e63f"
import script from "./TestimonialCard.vue?vue&type=script&lang=js"
export * from "./TestimonialCard.vue?vue&type=script&lang=js"

import "./TestimonialCard.vue?vue&type=style&index=0&id=7d02e63f&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__